import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { createContext as c, useState as u, useCallback as r, useEffect as f, useContext as g, useRef as m } from "react";
import { LoadingContainer as L } from "./styles.js";
import { Loading as p } from "../../../../components/Loading/index.js";
import { Theme as x } from "../../../../styles/themes/index.js";
import { useTranslation as C } from "../../../../hooks/useTranslation/index.js";
function v() {
  const { t } = C("common"), o = m(null);
  return /* @__PURE__ */ e(
    L,
    {
      id: "loading-editor",
      ref: o,
      "aria-label": t("loading-editor"),
      children: /* @__PURE__ */ e(p, { background: x.colors.Juliet })
    }
  );
}
const b = {
  startLoading: () => {
  },
  stopLoading: () => {
  },
  isLoading: !1
}, a = c(b);
function S({
  children: t,
  initial: o = !1
}) {
  const [i, n] = u(o), s = r(() => {
    n(!0);
  }, []), d = r(() => {
    n(!1);
  }, []);
  return f(() => {
    n(o);
  }, [o]), /* @__PURE__ */ l(
    a.Provider,
    {
      value: {
        startLoading: s,
        stopLoading: d,
        isLoading: i
      },
      children: [
        t,
        i ? /* @__PURE__ */ e(v, {}) : void 0
      ]
    }
  );
}
const T = () => g(a);
export {
  v as LoadingEditor,
  S as LoadingEditorProvider,
  T as useQuillLoading
};
